<ng-container
  *ngIf="{
    maxAllowableBalance: maxAllowableBalance$ | async,
    minAllowableBalance: minAllowableBalance$ | async,
    enabled: enabled$ | async,
    balanceIsNegative: balanceIsNegative$ | async,
    useBonusLimit: useBonusLimit$ | async,
    isValid: isValid$ | async,
    isSwitchDisabled: isSwitchDisabled$ | async,
  } as obs"
>
  <ng-container *ngIf="obs.enabled !== undefined">
    <div class="apply-bonus-form" [class.apply-bonus-form--disabled]="!obs.enabled">
      <div class="apply-bonus-form__header" *ngIf="!obs.balanceIsNegative">
        <div class="flex-container">
          <sd-switch
            [disabled]="obs.isSwitchDisabled"
            [checked]="obs.enabled"
            (changed)="enabledChanged($event)"
          ></sd-switch>

          <span>списать</span>
          <sd-bonus-widget [amount]="obs.maxAllowableBalance"></sd-bonus-widget>
        </div>

        <div *ngIf="obs.useBonusLimit && obs.maxAllowableBalance < minAllowedAmount">
          списание доступно от {{ minAllowedAmount | number }}
        </div>
      </div>

      <p *ngIf="obs.balanceIsNegative" class="apply-bonus-form__negative-warning">
        Баллы с отрицательным балансом не получится списать
      </p>

      <ng-container
        *ngIf="!obs.useBonusLimit ? obs.enabled : obs.enabled && obs.maxAllowableBalance >= minAllowedAmount"
      >
        <div class="apply-bonus-form__input">
          <input [formControl]="formControl" type="number" sdOnlyNumber="integer" />
          @if (obs.useBonusLimit && obs.isValid === false) {
            <span>не менее {{ minAllowedAmount | number }}</span>
          }
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
